import { cropImageAroundBbox } from "utils/cropImageAroundBbox";
import { scheduleIdleWork } from "utils/scheduleIdleWork";
import type { ScheduleIdleWorkHandle } from "utils/scheduleIdleWork";
import type {
  CropElementIconsInChunks,
  CropElementIconsInChunksItem,
} from "./types";

const CHUNK_MIN_TIME_REMAINING_MS = 2;
const ICON_OUTPUT_SIZE_PX = 120;

export const cropElementIconsInChunks: CropElementIconsInChunks = ({
  sourceImage,
  sourceWidthPx,
  sourceHeightPx,
  items,
  onIconCropped,
  onChunkComplete,
}) => {
  let isCancelled = false;
  let activeIdleWork: ScheduleIdleWorkHandle | null = null;

  const processChunk = (
    remainingItems: CropElementIconsInChunksItem[],
  ): void => {
    activeIdleWork = scheduleIdleWork((deadline) => {
      activeIdleWork = null;
      if (isCancelled) {
        return;
      }

      let processedCount = 0;
      while (
        processedCount < remainingItems.length &&
        (deadline.timeRemaining() > CHUNK_MIN_TIME_REMAINING_MS ||
          deadline.didTimeout ||
          processedCount === 0)
      ) {
        const nextItem = remainingItems[processedCount];
        processedCount += 1;
        const iconDataUrl = cropImageAroundBbox({
          sourceImage,
          bbox: nextItem.bbox,
          sourceWidthPx,
          sourceHeightPx,
          outputSizePx: ICON_OUTPUT_SIZE_PX,
        });
        onIconCropped(nextItem.cacheKey, iconDataUrl);
      }

      onChunkComplete();

      const stillRemaining = remainingItems.slice(processedCount);
      if (stillRemaining.length > 0) {
        processChunk(stillRemaining);
      }
    });
  };

  processChunk(items);

  return {
    cancel: () => {
      isCancelled = true;
      activeIdleWork?.cancel();
    },
  };
};
